

import React from 'react';
import nocloudsIllustration from '@/assets/noclouds.png';
import { EmptyState } from '../EmptyState';

export const NoFlyersAvailableEmptyState: React.FC = () => (
  <EmptyState
    title="No flyers currently available"
    description={"Check back at a later time."}
    illustration={nocloudsIllustration}
  />
);
